import { useState } from "react";
import Alert from "components/common/Alert";
import EventCategoryForm from "./EventCategoryForm";

export default function EventCategoryModal({
  initialData,
  onSubmit,
  onClose,
}) {
  const [modalError, setModalError] = useState("");

  return (
    <div className="p-6">
      {modalError && (
        <Alert
          type="error"
          message={modalError}
          onClose={() => setModalError("")}
        />
      )}

      <EventCategoryForm
        initialData={initialData}
        onSubmit={(payload) => onSubmit(payload, setModalError)}
      />
    </div>
  );
}
